import { Tag } from 'antd';
import {
  TIPO_DOCUMENTO,
  STATUS_REQUERIMENTO,
  ENUM_TIPO_PESSOA,
  ENUM_CARGO,
  ENUM_COLOR_DARK,
  ENUM_COLOR_LIGHT,
  ENUM_COLOR_CONTRAST,
} from 'utils/consts';
import { ENUM_TIPO_PERFIL } from 'utils/permissao';
import { duvidas, servicos } from 'routes/paths';
import { removeTodasMascaras } from 'utils/stringFormatter';

// VERIFICA SE DOCUMENTO É CNPJ OU CPF
export const verificarTipoDocumento = documento => {
  if (removeTodasMascaras(documento)?.length > 11) return TIPO_DOCUMENTO.CNPJ;
  return TIPO_DOCUMENTO.CPF;
};

// BUSCAR ASSUNTO PELA URL
export const getAssuntoUrl = () => {
  let assuntoUrl = window.location.pathname;
  switch (assuntoUrl) {
    case `${duvidas}`:
      assuntoUrl = 1;
      break;
    case `${servicos}`:
      assuntoUrl = 2;
      break;
    default:
      assuntoUrl = null;
  }
  return assuntoUrl;
};

// MONTA UMA URL PARA PESQUISAR EM FILTROS
export const montarUrlFiltro = (urlBase, filtro) => {
  let url = `${urlBase}`;
  let primeiroItem = true;
  if (filtro) {
    Object.keys(filtro).forEach(key => {
      if (filtro[key]) {
        if (primeiroItem) {
          url = `${url}?${key}=${filtro[key]}`;
          primeiroItem = false;
        } else {
          url = `${url}&${key}=${filtro[key]}`;
        }
      }
    });
  }
  return url;
};

export const getColorStatus = statusId => {
  let colorStatus = 'gray';
  let isClass = false;
  Object.keys(STATUS_REQUERIMENTO).forEach(key => {
    if (STATUS_REQUERIMENTO[key].id === statusId) {
      colorStatus = STATUS_REQUERIMENTO[key].colorName;
      if (colorStatus.includes('_')) isClass = true;
    }
  });
  return isClass ? { className: colorStatus } : { color: colorStatus };
};

export const getTipoPessoaPorId = idTipoPessoa => {
  if (idTipoPessoa?.toString() === '1') return ENUM_TIPO_PESSOA.fisica;
  if (idTipoPessoa?.toString() === '2') return ENUM_TIPO_PESSOA.juridica;
  return idTipoPessoa;
};

export const montarNovaJustificativa = arrayJustificativa => {
  if (!arrayJustificativa) return [];
  return arrayJustificativa;
};

export const montarDadosInputSelect = (array = [], idValue = 'id', idLabel = 'descricao') => {
  return array?.map(item => {
    return {
      value: item[idValue],
      label: item[idLabel],
    };
  });
};

export const montaNomeAtendente = nome => {
  const isSefaz = nome.indexOf('(');
  let nomeCompleto = nome.split(' ');
  nomeCompleto = nomeCompleto.filter(x => x.trim().length > 0);
  const len = nomeCompleto.length;
  let primeiraLetraUltNome = '';

  if (nomeCompleto.length === 1) return nome;

  if (isSefaz === -1) {
    primeiraLetraUltNome = nomeCompleto[len - 1].split('')[0];
  } else {
    primeiraLetraUltNome = nomeCompleto[len - 2].split('')[0];
  }
  return `${nomeCompleto[0]} ${primeiraLetraUltNome.toUpperCase()}.`;
};

export const getArrayStatusFormatted = () => {
  const array = [];
  Object.keys(STATUS_REQUERIMENTO).forEach(key => {
    array.push(STATUS_REQUERIMENTO[key]);
  });
  return array;
};

export const generateId = () => {
  return `${new Date().getSeconds()}-${new Date().getMilliseconds()}`;
};

export const primeiraLetraPalavraUpperCase = str => {
  try {
    const arr = str.toLowerCase().split(' ');
    for (let i = 0; i < arr.length; i++) {
      arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }
    return arr.join(' ') || str;
  } catch {
    return str;
  }
};

export const replaceFromTagHtml = (mensagem, titulo, sublinhado) => {
  const tituloFormatado = `<b>${titulo}</b>`;
  const sublinhadoFormatado = `<u>${sublinhado}</u>`;
  return `<p>${mensagem?.replace(titulo, tituloFormatado)?.replace(sublinhado, sublinhadoFormatado)}</p>`;
};

export const getLabelCargoFas = (cargoId, isSetorial) => {
  if (cargoId === ENUM_CARGO?.ATENDENTE && isSetorial) return ' Atendente Setorial';
  if (cargoId === ENUM_CARGO?.ATENDENTE) return ' Atendente';
  if (cargoId === ENUM_CARGO?.SUPERVISOR) return ' Supervisor';
  if (cargoId === ENUM_CARGO?.SUPERVISOR_SETORIAL) return ' Supervisor Setorial';
  return '';
};

export const getTipoPerfil = perfil => {
  if (perfil === ENUM_TIPO_PERFIL.ATENDENTE) return 'Atendente';
  if (perfil === ENUM_TIPO_PERFIL.SUPERVISOR) return 'Supervisor';
  if (perfil === ENUM_TIPO_PERFIL.SUPERVISOR_SETORIAL) return 'Supervisor Setorial';
  return perfil;
};

export const getColorTheme = idColor => {
  if (document.body.className === 'dark-theme') {
    return ENUM_COLOR_DARK[idColor];
  }
  if (document.body.className === 'contraste-theme') {
    return ENUM_COLOR_CONTRAST[idColor];
  }
  return ENUM_COLOR_LIGHT[idColor];
};

export const renderTag = tag => {
  return (
    <Tag {...getColorStatus(tag?.statusId)} key={tag}>
      {tag?.status.toUpperCase()}
    </Tag>
  );
};

export const compararPerfis = (userFas, userEsefaz) => {
  if (
    userEsefaz &&
    ((userFas?.cargoId === ENUM_CARGO.ATENDENTE && userEsefaz?.profile !== ENUM_TIPO_PERFIL.ATENDENTE) ||
      (userFas?.cargoId === ENUM_CARGO.SUPERVISOR && userEsefaz?.profile !== ENUM_TIPO_PERFIL.SUPERVISOR) ||
      (userFas?.cargoId === ENUM_CARGO.SUPERVISOR_SETORIAL &&
        userEsefaz?.profile !== ENUM_TIPO_PERFIL.SUPERVISOR_SETORIAL))
  ) {
    return sessionStorage.getItem('FORCE_ACCESS') !== null;
  }
  return true;
};

export const isPessoaJuridicaDadosCadastrais = (userEsefaz, pessoasDadosCadastrais) => {
  return userEsefaz?.document_type === 'CNPJ' && pessoasDadosCadastrais?.length === 2;
};

export const isPessoaJuridica = userEsefaz => {
  return userEsefaz?.document_type === 'CNPJ';
};
